import { render, staticRenderFns } from "./ExpertYearAssessIndex.vue?vue&type=template&id=67a75707&scoped=true"
import script from "./ExpertYearAssessIndex.vue?vue&type=script&lang=js"
export * from "./ExpertYearAssessIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a75707",
  null
  
)

export default component.exports